<div class="w-100">
    <div class="w-100 border-bottom p-3">
        <h3 class="mb-0 ml-4">Quote Detail</h3>
    </div>
    <quote-detail [editing]="editing" [directQuote]="quote" (updateChange)="this.service.recordChanges($event)" (documentsAdded)="onNewDocs($event)" (documentsDeleted)="onDocsDeleted($event)"></quote-detail>
</div>
